import React from 'react';
import styles from './ListFooter.module.sass';
import { format, getValueFromJson } from '../../utils';

const ListFooter = props => {
  const {
    footerElem,
    modifiers,
    header,
    footerStuck,
    footer,
    totalizers
  } = props;
  const modifiersClasses = (modifiers || []).map(m => styles[m]).filter(m => m).join(' ');
  return /*#__PURE__*/React.createElement("footer", {
    ref: footerElem,
    className: `${styles['footer']} ${footerStuck ? styles['is-stuck'] : ''}`,
    stuck: footerStuck ? 'true' : null
  }, /*#__PURE__*/React.createElement("div", {
    className: `${styles['totalizer']} ${modifiersClasses}`
  }, (header || []).map(({
    label,
    align,
    mobileHidden,
    width,
    basis,
    totalizerName,
    options
  }, index) => {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: `
                                ${styles[`align-${align}`] || ''} 
                                ${mobileHidden ? '' : styles['mobile']} 
                                ${width ? styles[width] || '' : ''}
                            `,
      style: basis && {
        flexBasis: basis
      }
    }, index === 0 ? /*#__PURE__*/React.createElement("small", null, footer[0]) : totalizers && (label || []).map((text, i) => {
      let textElem;

      if (totalizerName) {
        if (totalizerName in totalizers) {
          const formatedValue = format(totalizers[`${totalizerName}`], 'normal', getValueFromJson(options, 'currency'), getValueFromJson(options, 'fractionDigits'), getValueFromJson(options, 'locale'));
          textElem = /*#__PURE__*/React.createElement("h5", null, formatedValue);
        } else {
          textElem = /*#__PURE__*/React.createElement("h5", null);
        }
      } else {
        textElem = /*#__PURE__*/React.createElement("h5", null);
      }

      return /*#__PURE__*/React.createElement("div", {
        key: i
      }, textElem);
    }));
  })));
};

export default ListFooter;